import ReconciliationDetail from './ReconciliationDetail';

export default ReconciliationDetail;
